import api from '../services/api';

/**
 * Lista os prompts
 * @returns {object[]}
 */
export async function listPrompts() {
  const { data } = await api.get('prompts');
  return data;
}

/**
 * Recupera um prompt
 * @param {string} id id do prompt
 * @returns {object}
 */
export async function getPrompt(id) {
  const { data } = await api.get(`prompts/${id}`);
  return data;
}
